import React from 'react';
import { IconButton } from '@material-ui/core';
import { Edit, Visibility } from '@material-ui/icons';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#2D5CA6',
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14,
    paddingTop: 0,
    paddingBottom: 0
  }
}))(TableCell);

export const DeclarationItems = props => {
  return (
    <>
      <TableRow>
        <StyledTableCell>{props.index + 1}</StyledTableCell>
        <StyledTableCell>{props.item.n_number}</StyledTableCell>
        <StyledTableCell>{props.item.c_state}</StyledTableCell>
        <StyledTableCell>{props.item.d_state_change}</StyledTableCell>
        <StyledTableCell>
          <IconButton
            color="primary"
            size="small"
            onClick={() => {
              props.apllicantData(props.item.id);
            }}
            disabled={props.item.l_showedit === 0}
          >
            <Edit />
          </IconButton>
        </StyledTableCell>
        <StyledTableCell>
          <IconButton
            color="primary"
            size="small"
            onClick={() => {
              props.handleClickOpen(props.item.id);
            }}
            disabled={props.item.l_showpdf === 0}
          >
            <Visibility />
          </IconButton>
        </StyledTableCell>
        <StyledTableCell>{props.item.c_result}</StyledTableCell>
        <StyledTableCell>{props.item.n_sum}</StyledTableCell>
        <StyledTableCell>{props.item.n_kids}</StyledTableCell>
        <StyledTableCell>{props.item.d_from}</StyledTableCell>
        <StyledTableCell>{props.item.d_till}</StyledTableCell>
      </TableRow>
    </>
  );
};
